/*
These functions make sure WordPress
and Foundation play nice together.
*/
jQuery(document).ready(function() {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	// Slick Banner
	jQuery('.slick_banner').slick({
	  slidesToShow: 1,
	  slidesToScroll: 1,
    dots: false,
	  arrows: true,
	  infinite: true,
	  slideshow: true,
	  speed: 300,
	  autoplay: false,
	  autoplaySpeed: 2500,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
        }
      }
    ]
	});

  // Slick Products Slider
  jQuery('.products-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    infinite: true,
    slideshow: true,
    speed: 300,
    autoplay: false,
    autoplaySpeed: 2500
  });

	// FAQ SHIPPING POP UP
	jQuery('#faq').click(function() {
	    jQuery('#faq-content').show();
		}
	);
	jQuery('#modal-close').click(function() {
		jQuery('#faq-content').hide();
	});
	jQuery("#faq").click(function(event) {
		event.preventDefault();
	});

	jQuery('.menu-item-has-children').has("mouseover", function () {
		console.log('submenu');
	});


	jQuery(".menu-item-has-children").change(function() {
	  console.log( "Handler for .change() called." );
	});

  // Make the menu sticky on scroll
  stickyMenuScrollFunction();
}); 

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function stickyMenuScrollFunction() {
  jQuery(window).scroll(function() {
    var topbar = jQuery('#header .top-bar').outerHeight();

    // var headerheight = jQuery('#header').height();
    // var mainhight = headerheight - topbar;
    var myheight = jQuery(window).scrollTop();

    if(myheight > topbar){
      jQuery('#header .menu-bar').addClass('headersticky');
    }
    if(myheight < topbar){
      jQuery('#header .menu-bar').removeClass('headersticky');
    }
    if(myheight == 0){
      jQuery('#header .menu-bar').removeClass('headersticky');
    }    		
  });
}


/**************************************************
 * Make service columns equal height
 **************************************************/
function equalRowHeightServices(container){
  var currentTallest = 0;

  // Find height
  jQuery(container).each(function() {
    var $el = jQuery(this);

    currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
    // console.log($el.height() + ' ' + currentTallest);
  });

  // console.log(currentTallest);

  // Set equal height
  jQuery(container).each(function() {
    jQuery(this).height(currentTallest);
  });
}

jQuery(window).load(function() {
  var windowWidth = window.innerWidth || jQuery(window).width();
  // Not on mobile
  if(windowWidth > 767) {
    equalRowHeightServices('.service_column .item_content .service_items');
  }
});

jQuery(window).resize(function(){
  var windowWidth = window.innerWidth || jQuery(window).width();
  // Not on mobile
  if(windowWidth > 767) {
    equalRowHeightServices('.service_column .item_content', '.service_items');
  }
});